<template>
  <div class="home flex-center">
    <logo-title :title="title"/>
    <test-result v-if="isFinishedTest"/>
    <div v-else class="contents">
      <div class="question-content flex-center" v-if="isReadyTest">
        <question :text="question"/>
        <div class="progress flex-center" v-if="currentCards">
          <k-progress 
            status="success" 
            type="line"
            :percent="percentAnswer"
            :line-height="10"
            :color-flow="true"
            :color="['#40a9ff', '#5cdbd3']"
            :show-text="false"
          />
        </div>
        <div class="deck" v-if="currentCards">
          <card 
            v-for="(cardData, index) in currentCards"
            :imgSrc="cardData.imgPath"
            :key="cardData.id"
            @chooseCard="chooseCard(index)"
          />
        </div>
      </div>
      <div class="fade-up flex-center" v-else>
        <span class="ready-message" :class="{ 'slide-bar' : !$route.query.skip }">
          당신의 성향에 어울리는 색상을 찾아드립니다
        </span>
        <span class="ready-message" :class="{ 'slide-bar' : !$route.query.skip }">
          총 검사 시간은 5분 내외입니다
        </span>
        <span class="ready-message" :class="{ 'fade-up' : !$route.query.skip }">
          현재까지 약 <span class="user-count">{{userCount.toLocaleString()}}</span> 회 진행된 테스트 입니다.
        </span>
        <div class="button" :class="{ 'fade-up' : !$route.query.skip }" @click="startTest">
          테스트 시작
        </div>
        <div class="share-container">
          <img class="link-icon" src="icon_images/link_clipboard.png" alt="링크 복사하기" @click="copyToClipboard()">
          <img class="link-icon" src="icon_images/link_kakao.png" alt="카카오 공유하기" @click="sendKakaoLink()">
          <img class="link-icon" src="icon_images/link_facebook.png" alt="페이스북 공유하기" @click="sendFacebookLink()">
          <img class="link-icon" src="icon_images/link_twitter.png" alt="트위터 공유하기" @click="sendTwitterLink()">
        </div>
      </div>
    </div>
    <img :src="cardData.imgPath" v-show="false" v-for="(cardData) in previewCards" :key="cardData.id">
  </div>
</template>

<script>
import LogoTitle from '@/components/LogoTitle.vue'
import Question from '@/components/Question.vue'
import Card from '@/components/Card.vue'
import TestResult from '@/components/TestResult.vue'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import firebaseUtil from "@/firebaseUtil";

export default {
  name: 'Home',
  components: {
    LogoTitle,
    Question,
    Card,
    TestResult
  },
  data() {
    return {
      isReadyTest: false,
      userCount: 0
    };
  },
  computed: {
    ...mapState(["title", "question", "currentQuestionNumber", "chosenCards", "cardImages", "yourColorName", "skip"]),
    ...mapGetters(["currentCards", "percentAnswer", "previewCards"]),
    isFinishedTest() {
      return this.$route.params.color;
    }
  },
  methods: {
    ...mapMutations(["skipTitleAnimation", "randomTest", "setQuestionNumber"]),
    ...mapActions(["randomTest", "nextCards"]),
    sendKakaoLink() {
      Kakao.Link.sendScrap({
        requestUrl: `https://colorpersonality.web.app`,
        templateArgs: {
          "name": this.yourColorName,
        }
      });
    },
    sendFacebookLink() {
      window.open("https://www.facebook.com/sharer/sharer.php"
        +"?u="+`https://colorpersonality.web.app`);
    },
    sendTwitterLink() {
      window.open("https://twitter.com/intent/tweet"
        +"?via=kipacti"
        +"&text="+encodeURIComponent("당신의 색깔 성향을 찾아드립니다. Color Personality")
        +"&url="+`https://colorpersonality.web.app`);
    },
    copyToClipboard() {
      const createInput = document.createElement("input");
      createInput.setAttribute("type", "text");
      document.getElementById("app").appendChild(createInput);
      createInput.value = `https://colorpersonality.web.app`;
      createInput.select();
      document.execCommand('copy');
      document.getElementById("app").removeChild(createInput);
      alert('공유 링크를 복사하였습니다');
    },
    startTest(){
      this.isReadyTest = true;
      this.setQuestionNumber(this.currentQuestionNumber+1);
    },
    chooseCard(selectedCard) {
      const questionNumber = this.currentQuestionNumber;
      const card = selectedCard;
      this.nextCards(selectedCard);
      if (!this.currentCards)
      {
        this.eventLog(questionNumber, card, this.yourColorName);
        this.$router.replace(this.yourColorName);
      }
    },
    eventLog(questionNumber, selectedCard, colorName)
    {
      const firebaseAnalytics = firebaseUtil.analytics();
      firebaseAnalytics.logEvent("answers", {
        [`answers${questionNumber+1}`] : selectedCard
      });

      firebaseAnalytics.logEvent("color", {
        "color" : colorName
      });

      if (this.$session.has(this.yourColorName)) {
        return;
      } else {
        this.$session.set(this.yourColorName, true);
      }

      const userRef = firebaseUtil.firestore().collection("statistics").doc("users");
      userRef.get().then((doc)=> {
        let count = 0;
        if (doc.exists) {
          const _data = doc.data();
          count = _data.count;
        }
        userRef.set({
          count: count + 1,
        });
      });
      
      const testResultRef = firebaseUtil.firestore().collection("test-results").doc(this.yourColorName);
      const resultChosenColor = {};
      this.chosenCards.forEach((card, i)=>resultChosenColor[i] = card);

      testResultRef.get().then((doc)=> {
        let count = 0;
        let selectedCards = [];
        if (doc.exists) {
          const _data = doc.data();
          selectedCards = _data.selectedCards;
          count = _data.selectedCards.length;
        }

        selectedCards.push(resultChosenColor);

        testResultRef.set({
          color: this.yourColorName,
          count: selectedCards.length,
          selectedCards
        });
      });
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log(to.params.color);
    next();
  },
  async mounted() {
    const userRef = firebaseUtil.firestore().collection("statistics").doc("users");
    userRef.get().then((doc)=> {
      if (doc.exists) {
        const _data = doc.data();
        this.userCount = _data.count;
      }
    });
  }
}
</script>

<style>
.stop-dragging {
  -ms-user-select: none; 
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  user-select: none;
}
.only-text-dragging {
  user-select: text
}
.k-progress {
  width: 45%;
}
div.k-progress-outer {
  padding-right: 0px;
}
</style>
<style scoped>
.link-icon {
  width: 2.4rem;
  margin: 0 4px 0 2px;
  transition-duration: 0.2s;
}
.link-icon:hover {
  cursor: pointer;
  opacity: 0.8;
}
.share-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px;
}
.home {
  padding-top: 50px;
  height: 100%;
}
.deck {
  display: flex;
  justify-content: center;
  padding: 0 5%;
}
.ready-message {
  font-size: 1.7rem;
  margin: 10px;
}
.ready-message:nth-child(2) {
  animation-delay: 2.0s;
}
.ready-message:nth-child(2)::before {
  font-size: 1.4rem;
  animation-delay: 1.5s;
}
.ready-message::before {
  background: rgb(26, 26, 26);
  animation-delay: 0.6s;
}
.button {
  margin: 50px;
  margin-bottom: 10px;
  font-size: 2.0rem;
  background: #383838;
  color: white;
  padding: 0.5rem 0.8rem;
}
.button:hover {
  cursor: pointer;
}
.button.fade-up{
  transition-duration: 0.3s;
  animation-delay: 3.0s;
}
.ready-message.fade-up {
  transition-duration: 0.3s;
  animation-delay: 2.7s;
}

.button:hover, .ready-message.fade-up:hover {
  color: black;
  background-color: white;
}
.progress {
  margin: 15px;
  width: 100%;
  margin-bottom: 5px;
}
.progress span {
  background: rgb(26, 26, 26);
  font-size: 0.1rem;
  border-radius: 2px;
  margin: 0px 3px;
  color: rgb(26, 26, 26);
}
@media screen and (max-width: 600px) {
  .ready-message {
    font-size: 0.95rem;
  }
}
@media screen and (max-width: 800px) {
  .deck {
    flex-flow: wrap;
    padding: 0 5%;
  }
}
@media screen and (min-width: 800px) {
  .deck {
    padding: 0 10%;
  }
}
.contents {
  margin-top: 20px;
}
.user-count {
  color: crimson;
}
</style>